import type { LayoutConfig } from "../../hooks/useLayoutConfig";

export const accountAdminLayoutConfig: LayoutConfig = {
  topBar: {
    hideRoutes: ["/verify/*"],
  },
  sidebar: {
    hideRoutes: ["/public/*", "/verify/*"],
    mobileHideRoutes: ["/verify/*"],
  },
  overlays: {
    hideRoutes: ["/verify/*"],
  },
  skeleton: {
    hideRoutes: ["/verify/*"],
  },
};
